import { type ReactNode, type FC } from "react";
import styles from "./Selector.module.css";
import Tooltip from "./Tooltip";
interface Props {
  children?: ReactNode;
  selected?: boolean;
  onClick?: (name?: string) => void;
  icon?: React.ReactNode;
  name?: string;
  disabled?: boolean;
  className?: string;
}

const Selector: FC<Props> = ({
  selected,
  onClick,
  icon,
  children,
  name,
  disabled,
  className = "",
}) => {
  return (
    <div
      role={"selector"}
      tabIndex={0}
      onKeyUp={(e) => {
        if (e.code === "Space") {
          onClick?.(name);
        }
      }}
      onClick={() => onClick?.(name)}
      className={`${styles.container} ${selected ? styles.selected : ``} ${
        disabled ? styles.disabled : ``
      } ${className}`}
    >
      {icon && (
        <div className={"flex justify-center text-gray-400"}>{icon}</div>
      )}
      <Tooltip
        triggerContainerClassName={"overflow-hidden"}
        trigger={
          <span className={"whitespace-nowrap overflow-hidden text-ellipsis"}>
            {children}
          </span>
        }
      >
        {children}
      </Tooltip>
    </div>
  );
};

export default Selector;
